import axios from 'axios';
import {
  GET_SUBMISSION_FORMS,
  GET_SUBMISSION_FORMS_LIST,
  GET_SUBMISSION_FORMS_MINIMAL,
  GET_SUBMISSION_FORM,
  ADD_SUBMISSION_FORM,
  DELETE_SUBMISSION_FORM,
  UPDATE_SUBMISSION_FORM,
  SUBMISSION_FORMS_LOADING,
  SUBMISSION_FORM_LOADING,
  CLEAR_CURRENT_SUBMISSION_FORM,
  SET_SUBMISSION_FORMS_PAGE
} from './types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';

// Get lightweight submission forms list with pagination and filtering (for table display)
export const getSubmissionFormsList = (page = 1, limit = 10, filters = {}) => (dispatch, getState) => {
  dispatch(setSubmissionFormsLoading());

  // Build query string with pagination and filters
  let queryParams = `page=${page}&limit=${limit}`;
  
  if (filters.title && filters.title.length > 0) {
    const encodedTitles = filters.title.map(title => encodeURIComponent(title));
    queryParams += `&title=${encodedTitles.join(',')}`;
  }
  if (filters.course && filters.course.length > 0) {
    const encodedCourses = filters.course.map(course => encodeURIComponent(course));
    queryParams += `&course=${encodedCourses.join(',')}`;
  }
  if (filters.requirements && filters.requirements.length > 0) {
    const encodedRequirements = filters.requirements.map(req => encodeURIComponent(req));
    queryParams += `&requirements=${encodedRequirements.join(',')}`;
  }
  if (filters.autoApproval !== null && filters.autoApproval !== undefined) {
    queryParams += `&autoApproval=${encodeURIComponent(filters.autoApproval)}`;
  }
  if (filters.repeatable !== null && filters.repeatable !== undefined) {
    queryParams += `&repeatable=${encodeURIComponent(filters.repeatable)}`;
  }
  if (filters.tags && filters.tags.length > 0) {
    const encodedTags = filters.tags.map(tag => encodeURIComponent(tag));
    queryParams += `&tags=${encodedTags.join(',')}`;
  }

  axios
    .get(`/api/submissionForms/list?${queryParams}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_SUBMISSION_FORMS_LIST, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Get single submission form by ID (for view/edit pages)
export const getSubmissionForm = (id) => (dispatch, getState) => {
  dispatch(setSubmissionFormLoading());
  axios
    .get(`/api/submissionForms/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: GET_SUBMISSION_FORM, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

// Clear current submission form
export const clearCurrentSubmissionForm = () => {
  return { type: CLEAR_CURRENT_SUBMISSION_FORM };
};

// Get minimal submission forms list (for dropdowns/selectors - returns only _id, title, and repeatable)
export const getSubmissionFormsMinimal = () => (dispatch, getState) => {
  dispatch(setSubmissionFormsLoading());
  axios
    .get('/api/submissionForms/minimal', tokenConfig(getState))
    .then(res => dispatch({ type: GET_SUBMISSION_FORMS_MINIMAL, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

// DEPRECATED: Use getSubmissionFormsList() instead
export const getSubmissionForms = () => (dispatch, getState) => {
  dispatch(setSubmissionFormsLoading());
  axios
    .get('/api/submissionForms', tokenConfig(getState))
    .then(res => dispatch({ type: GET_SUBMISSION_FORMS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

// Get submission forms assigned to the authenticated student's program
export const getStudentSubmissionForms = () => (dispatch, getState) => {
  dispatch(setSubmissionFormsLoading());
  axios
    .get('/api/submissionForms/student/program-forms', tokenConfig(getState))
    .then(res => dispatch({ type: GET_SUBMISSION_FORMS, payload: res.data }))
    .catch(err => dispatch(returnErrors(err.response?.data, err.response?.status)));
};

export const addSubmissionForm = form => (dispatch, getState) => {
  return axios
    .post('/api/submissionForms', form, tokenConfig(getState))
    .then(res => {
      dispatch({ type: ADD_SUBMISSION_FORM, payload: res.data });
      return res.data;
    })
    .catch(err => {
      dispatch(returnErrors(err.response.data, err.response.status));
      throw err;
    });
};

export const updateSubmissionForm = (id, form) => (dispatch, getState) => {
  return axios
    .put(`/api/submissionForms/${id}`, form, tokenConfig(getState))
    .then(res => {
      dispatch({ type: UPDATE_SUBMISSION_FORM, payload: res.data });
      return res.data;
    })
    .catch(err => {
      dispatch(returnErrors(err.response.data, err.response.status));
      throw err;
    });
};

export const deleteSubmissionForm = id => (dispatch, getState) => {
  axios
    .delete(`/api/submissionForms/${id}`, tokenConfig(getState))
    .then(res => dispatch({ type: DELETE_SUBMISSION_FORM, payload: id }))
    .catch(err => dispatch(returnErrors(err.response.data, err.response.status)));
};

export const setSubmissionFormsLoading = () => {
  return { type: SUBMISSION_FORMS_LOADING };
};

export const setSubmissionFormLoading = () => {
  return { type: SUBMISSION_FORM_LOADING };
};

// Set current page number (without fetching data)
export const setSubmissionFormsPage = (page) => {
  return { type: SET_SUBMISSION_FORMS_PAGE, payload: page };
}; 